export const CompanyInitializer = async (companyStore, assessmentsStore, usersStore, modulesStore, companyId = undefined) => {
    if (!companyId) {
        return;
    }

    await companyStore.loadCompany(companyId);

    const loaders = [
        assessmentsStore.loadCompanyAssessments(companyId),
        modulesStore.load(companyId),
    ];

    if (usersStore.currentUser.userType !== 'Sales Member') {
        loaders.push(usersStore.loadCompanyUsers(companyId));
    }

    await Promise.all(loaders);
};